import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {trigger, state, style, transition, animate} from '@angular/animations';
import {ReleaseOrderService} from "../../../services/release-order.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatTableDataSource} from "@angular/material/table";

export interface DialogData {
    title: string,
    subTitle: string,
    description: string,
    descriptionArray: any,
    label1: string,
    label2: string,
    label3: string,
    supportTextForlabel3: string,
    positiveAction: CallableFunction,
    negativeAction: CallableFunction,
    extraAction: CallableFunction,
    action?: boolean,
    parent: any,
}

@Component({
    selector: 'logzy-map-do',
    templateUrl: './map-do.component.html',
    styleUrls: ['./map-do.component.scss', '../../dialog-box/dialog-box.scss'],
    animations: [
        trigger('flipAnimation', [
            state('front', style({transform: 'rotateY(0deg)'})),
            state('back', style({transform: 'rotateY(180deg)'})),
            transition('front <=> back', [
                animate('0.6s ease-in-out')
            ])
        ])
    ]
})
export class MapDoComponent implements OnInit {

    set: boolean = true;
    title: string = 'Info';
    subTitle: string = "The current task have issues";
    isFlipped: boolean = false;
    supplyDo: string = '';

    constructor(
        public dialogRef: MatDialogRef<MapDoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private releaseService: ReleaseOrderService,
        private snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {
        this.supplyDo = this.data.supplyDO;
    }

    newRequest() {
        window.open(window.location.origin + '/requests/request-data', '_self');
    }

    mapRequest() {
        this.releaseService.getReleaseOrdersForMapping(this.supplyDo).subscribe(res => {
            console.log('this.containers', res);
            this.isFlipped = true;
        })
    }

    skip() {
        this.dialogRef.close();
    }

    back() {
        this.isFlipped = false;
    }

    mapDO() {

    }
}
